require("./gallery");

import "@/gallery/widget.scss";
import { TProductCode } from "./interfaces";

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $refs: {
      [key: string]: HTMLElement | any;
    };
  }
}

declare global {
  interface Window {
    frisbuyFavoriteList?: Array<TProductCode>;
  }
}
